module.exports = __webpack_public_path__ + "static/img/icon_img2.752d79de.png";